import {Component, OnInit} from '@angular/core';
import {EinstiegComponent} from "../einstieg/einstieg.component";
import {UntypedFormControl, Validators} from "@angular/forms";

/**
 * Component for the external entry of the moderat, showing some extra fields. Let the user select its interests.
 */
@Component({
  selector: 'app-moderat-external-entry',
  templateUrl: './external-entry.component.html'
})
export class ExternalEntryComponent extends EinstiegComponent implements OnInit {

  /**
   * Definition of the fields that should be shown on the external entry.
   */
  fieldConfig: {name: string, type: string, label: string, classes: string, required: boolean}[] = [];

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    // get fieldConfig
    this.fieldConfig = JSON.parse(this.portalService.getConfig("external.extraFields"));

    // init fields on form
    if(this.fieldConfig) {
      this.fieldConfig.forEach(field => {
        const validators = [];
        if (field.required === true) {
          validators.push(Validators.required);
        }
        this.form.addControl(field.name, new UntypedFormControl(this.anfrage.extraFields[field.name] ?? null, validators));
      });
    }
  }

  /**
   * @inheritDoc
   */
  onSubmit() {
    // get data of extra fields and save to anfrage
    if(this.form.valid === true) {
      this.fieldConfig.forEach(field => {
        this.anfrage.extraFields[field.name] = this.form.get(field.name).value;
      });
    }

    super.onSubmit();
  }
}
